/** @jsxImportSource @emotion/react */

import { COLORS } from '@btime/constants'
import { css } from '@emotion/react'
import React from 'react'

const List = ({ noBorder, minWidth, minHeight, ...props }) => {
  const style = css`
    ${!noBorder ? `border-top: solid 1px ${COLORS.light2};` : ''}
    min-width: ${minWidth};
    min-height: ${minHeight};
  `

  return <div css={style} {...props} />
}

export default List
